import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"

import { CenterEverythingColumn } from "../../../../../common/components/Column"
import { useSearchParamsState } from "../../../../../common/utils"
import { useScrollToTargetElementRef } from "../../../utils"
import { EVENT_TYPES } from "../../data"
import { GLOBAL_SEARCH_URL_PARAMS } from "../../data"
import { AccordionSummaryContent, StyledAccordion } from "./Accordions"
import CallRepresentation from "./CallRepresentation"
import { performedBySubtitle } from "./PerformedByAttribution"
import TabColumn from "./TabColumn"
import TabContentColumn from "./TabContentColumn"
import TabHeaderRow from "./TabHeaderRow"
import ActivitySkeleton from "./components/ActivitySkeleton"

export default function CallsTab({
  candidate,
  onMakeCallButtonClicked,
  isLoading = false,
}) {
  const events = candidate.crm_events
    .filter((event) => event.type === EVENT_TYPES.call)
    .slice()
    .sort((a, b) => new Date(b.created) - new Date(a.created))

  return (
    <TabColumn>
      <TabHeaderRow title="Call Logs">
        <Button
          variant="outlined"
          color="inherit"
          startIcon={<PhoneOutlinedIcon />}
          onClick={onMakeCallButtonClicked}
          disabled={Boolean(candidate.is_dnc)}
        >
          Make Call
        </Button>
      </TabHeaderRow>
      <TabContentColumn>
        {isLoading ? (
          <ActivitySkeleton />
        ) : events.length === 0 ? (
          <CenterEverythingColumn>
            <Typography variant="body1" color="text.secondary">
              No calls made yet.
            </Typography>
          </CenterEverythingColumn>
        ) : (
          events.map((callEvent) => (
            <Call key={callEvent.id} callEvent={callEvent} />
          ))
        )}
      </TabContentColumn>
    </TabColumn>
  )
}

function Call({ callEvent }) {
  const [expandedEventID, setExpandedEventID] = useSearchParamsState(
    GLOBAL_SEARCH_URL_PARAMS.call
  )
  const scrollRef = useScrollToTargetElementRef(
    callEvent,
    GLOBAL_SEARCH_URL_PARAMS.call
  )

  return (
    <StyledAccordion
      key={callEvent.id}
      expanded={callEvent.id === parseInt(expandedEventID)}
      onChange={(e, expanded) =>
        setExpandedEventID(expanded ? callEvent.id : null)
      }
      ref={scrollRef}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <AccordionSummaryContent
          Icon={<PhoneOutlinedIcon />}
          accordionTitle={
            callEvent.disposition ? "Logged a call attempt" : "Logged a call"
          }
          subtitle={performedBySubtitle(callEvent)}
          dateStr={callEvent.created}
        />
      </AccordionSummary>
      <AccordionDetails>
        <CallRepresentation crmEvent={callEvent} />
      </AccordionDetails>
    </StyledAccordion>
  )
}
